import { mapActions, mapState } from 'vuex'
import playerBadge from '@/components/player-badge/player-badge.vue'

export default {
  components: {
    playerBadge
  },
  data () {
    return {
      tab: this.$route.meta.tab || 0,
      isLoading: false,
      cityGameForm: {
        status: '',
        team: '',
        time: ''
      },
      cityGameFormStatuses: [
        { value: '', label: 'Brak zgłoszenia' },
        { value: 'waiting', label: 'Oczekuje' },
        { value: 'out', label: 'Odrzucony' },
        { value: 'accepted', label: 'Zaakceptowany' }
      ]
    }
  },
  computed: {
    ...mapState(['badges', 'superBadges', 'players', 'teams', 'user']),
    player () {
      const player = this.players[this.$route.params.playerId]
      if (player && player.cityGame) {
        this.cityGameForm.status = player.cityGame.status
        this.cityGameForm.team = player.cityGame.team
        this.cityGameForm.time = player.cityGame.time
      }
      return player
    },
    team () {
      return this.teams[this.player.assignedTeam]
    },
    details () {
      const details = [
        {
          name: 'assignedTeam',
          icon: 'mdi-account-group',
          subtitle: 'Drużyna na Dragon Cup',
          value: this.team ? this.team.name : null,
          link: { name: 'team', params: { teamId: this.team ? this.team.id : null } }
        },
        {
          name: 'team',
          icon: 'mdi-account-group',
          subtitle: 'Drużyna domowa',
          value: this.player ? this.player.team : null
        },
        {
          name: 'city',
          icon: 'mdi-city',
          subtitle: 'Miasto',
          value: this.player ? this.player.city : null
        },
        {
          name: 'position',
          icon: 'mdi-account',
          subtitle: 'Pozycja na boisku',
          value: this.player && this.$t(`register_position_${this.player.position}`) !== `register_position_${this.player.position}` ? this.$t(`register_position_${this.player.position}`) : null
        },
        {
          name: 'infoEdition',
          icon: 'mdi-counter',
          subtitle: 'To moja X edycja Dragon Cupa:',
          value: this.player ? this.player.infoEdition : null
        },
        {
          name: 'infoChat',
          icon: 'mdi-chat',
          subtitle: 'Możesz ze mną pogadać o:',
          value: this.player ? this.player.infoChat : null
        },
        {
          name: 'infoUltimate',
          icon: 'mdi-note',
          subtitle: 'Moja historia ultimate:',
          value: this.player ? this.player.infoUltimate : null
        }
      ]
      return details.filter(d => d.value)
    },
    badgesToGain () {
      const playerBadges = this.player.badges || []
      return this.badges.filter(badge => !playerBadges.includes(badge.id))
    },
    superBadgesToGain () {
      const playerBadges = this.player.badges || []
      return this.superBadges.filter(badge => !playerBadges.includes(badge.id))
    },
    badgesCount () {
      return (this.player.badges || []).filter(b => b !== 'organizer').length
    }
  },
  methods: {
    ...mapActions(['patchIsAdmin', 'patchCityGame']),
    saveCityGame () {
      this.isLoading = true
      this.patchCityGame({ playerId: this.player.id, data: this.cityGameForm }).finally(() => {
        this.isLoading = false
      })
    },
    toggleAdmin () {
      this.isLoading = true
      this.patchIsAdmin({ playerId: this.player.id }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
